// Component to display when there are no jobs after filtering
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import colors from 'styles/colors';

const NoSearchResults = () => (
  <Box
    sx={{
      display: 'flex',
      height: '100%',
      width: '100%',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '40px 0',
    }}
  >
    <Box>
      <Typography variant="h5" color={colors.text.primary}>
        No data found
      </Typography>
      <Typography variant="body2" sx={{ color: colors.text.tetriary, padding: '20px 0' }}>
        No jobs match your search criteria
      </Typography>
    </Box>
  </Box>
);

export default NoSearchResults;
